<template>
  <div class="panel-header panel-header-lg">
    <header-chart :height="255"
    :chart-data="chartData"
    :options="optionsArr"
    >
  </header-chart>

  <canvas id="canvasMaluco"></canvas>
</div>
</template>

<script>
  import { EventBus } from '@/services/EventBus.js'
  import HeaderChart from './HeaderChart'

  export default {
    name: 'overview-header',
    components: {
      HeaderChart
    },
    data(){
      return {
        chartData: {},
        optionsArr: {
      layout: {
        padding: {
          left: 20,
          right: 20,
          top: 0,
          bottom: 0
        }
      },
      maintainAspectRatio: false,
      tooltips: {
        backgroundColor: '#fff',
        titleFontColor: '#333',
        bodyFontColor: '#666',
        bodySpacing: 4,
        xPadding: 12,
        callbacks: {
            label: function(tooltipItems, data) { 
                return "R$ " + tooltipItems.yLabel;
            }
        }
      },
      legend: {
        position: 'bottom',
        fillStyle: '#FFF',
        display: false
      },

      elements: {
          line: {
            fill: true,
            color: "#fff",
            backgroundColor: "#ffffff6e",
          }
      },
      scales: {
        yAxes: [{
          ticks: {
            fontColor: '#fff',
            fontStyle: 'bold',
            beginAtZero: true,
            maxTicksLimit: 5,
            padding: 10
          },
          gridLines: {
            drawTicks: true,
            drawBorder: false,
            display: true,
            zeroLineColor: 'transparent'
          }

        }],
        xAxes: [{
          gridLines: {
            zeroLineColor: 'transparent',
            display: false

          },
          ticks: {
            padding: 10,
            fontColor: '#fff',
            fontStyle: 'bold'
          }
        }]
      }
      }}
    },
      mounted() {
        EventBus.$on('dashboardHeaderData', (data) => {
          let chartColor = '#fff';
          const ctx = document.getElementById('canvasMaluco').getContext('2d');
          const gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
          gradientStroke.addColorStop(0, '#fff');
          gradientStroke.addColorStop(1, chartColor);

          const gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
          gradientFill.addColorStop(0, 'rgba(255, 255, 255, 0)');
          gradientFill.addColorStop(1, 'rgba(255, 255, 255, 0.24)');

          this.chartData = {
            labels: data.labels,
            datasets: [{
              label: 'Valor',
              borderColor: chartColor,
              backgroundColor: gradientFill,
              pointBorderColor: chartColor,
              pointBackgroundColor: '#fff',
              pointHoverBackgroundColor: '#19a4e6',
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              borderWidth: 2,
              data: data.data,
            }]
          }
        })

  }

  }
</script>

<style scoped>

</style>
